export { InvestorPage as default } from '@/components/pages/Ir/Investor'
